// extracted by mini-css-extract-plugin
export default {"get_it_now_v2":"Wl","place_order_copy":"Xl","next_order_copy":"Yl","title_wrapper":"Zl","get_it_now_row":"am","get_it_now_remaining_items":"bm","get_it_now_remaining_items_mob":"cm","order_summary":"em","additional_items":"fm","account_content_slider":"gm","ingredient_carousel":"hm","ingredient_carouselwrapper":"im","account_content_slide":"jm","account_subscription_section_mob":"km","carouselwrapper":"lm"};
    if(module.hot) {
      // 1738064236099
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  